import React from 'react';
import { ArrowRight } from 'lucide-react';
export function Transformation() {
  return <section className="py-16 px-4 bg-gray-900 text-white" data-id="element-177">
      <div className="max-w-5xl mx-auto" data-id="element-178">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-179">
          🔄 Antes vs Después
        </h2>

        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-180">
          {/* Before */}
          <div className="bg-red-500/10 border border-red-500/30 p-8 rounded-2xl" data-id="element-181">
            <h3 className="text-2xl font-bold text-red-400 mb-6 flex items-center gap-2" data-id="element-182">
              ❌ Antes del MegaPack
            </h3>
            <ul className="space-y-4" data-id="element-183">
              {['Noches interminables', 'Despertares constantes', 'Llanto y frustración', 'Dudas y culpa', 'Cansancio extremo'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-300" data-id="element-184">
                  <span className="text-red-500" data-id="element-185">✖</span>
                  {item}
                </li>)}
            </ul>
          </div>

          {/* Arrow for desktop */}
          <div className="hidden md:flex justify-center text-gray-500" data-id="element-186">
            <ArrowRight className="w-12 h-12" data-id="element-187" />
          </div>

          {/* After */}
          <div className="bg-green-500/10 border border-green-500/30 p-8 rounded-2xl relative overflow-hidden" data-id="element-188">
            <div className="absolute top-0 right-0 bg-green-500 text-black text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-189">
              TU META
            </div>
            <h3 className="text-2xl font-bold text-green-400 mb-6 flex items-center gap-2" data-id="element-190">
              ✅ Después del MegaPack
            </h3>
            <ul className="space-y-4" data-id="element-191">
              {['Bebé más regulado', 'Menos despertares nocturnos', 'Siestas más largas', 'Menos llanto', 'Más descanso y conexión'].map((item, i) => <li key={i} className="flex items-center gap-3 text-white font-medium" data-id="element-192">
                  <span className="text-green-500" data-id="element-193">✔</span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="text-center text-gray-400 mt-12 text-lg italic" data-id="element-194">
          No perfección. Progreso real y sostenible.
        </p>
      </div>
    </section>;
}